import React from 'react';

import { Container } from '../Container/Container';

export const Banner = ({
  className = '',
  children,
  innerClassName = '',
  ...rest
}: { innerClassName?: string } & React.HTMLAttributes<HTMLDivElement>) => (
  <div className={`w-full ${className}`} {...rest}>
    <Container className={innerClassName}>{children}</Container>
  </div>
);
